module.exports = __webpack_public_path__ + "img/firefighter_main2.190f5279.jpg";